module.exports = __webpack_public_path__ + "1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/1.jpg
// module id = 43
// module chunks = 0